var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('div', {
    staticClass: "public-container"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "logo"
    }
  })])], 1), _c('div', {
    staticClass: "inner-content",
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('router-view')], 1)]), _c('div', {
    staticClass: "policy"
  }, [_c('a', {
    attrs: {
      "href": _vm.privacyPolicyUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("Privacy Policy")))]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": _vm.termsAndConditionsUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("Terms and Conditions")))]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": _vm.supportUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("Support")))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }